import { Provider } from "@overmap-ai/blocks"
import { memo, type PropsWithChildren, useLayoutEffect } from "react"

import { useAppSelector } from "../store"
import { selectAppearance, selectThemePalette } from "../store/selectors"

export const ThemeProvider = memo<PropsWithChildren>((props) => {
	const { children } = props

	const themePalette = useAppSelector(selectThemePalette)
	const appearance = useAppSelector(selectAppearance)

	useLayoutEffect(() => {
		if (appearance !== "light") {
			document.documentElement.classList.add("dark")
		} else {
			document.documentElement.classList.remove("dark")
		}
	}, [appearance])

	useLayoutEffect(() => {
		document.documentElement.setAttribute(`data-theme`, themePalette)
	}, [themePalette])

	return (
		<Provider accentColor="primary" radius="md">
			{children}
		</Provider>
	)
})
ThemeProvider.displayName = "ThemeProvider"
